import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";
import ADIRfqPopupCartNotificationModal from "./ADIRfqPopupCartNotificationModal";
import ADIRfqPopupNonReturnableModal from "./ADIRfqPopupNonReturnableModal";
import ADILogicBrokerModal from "./ADILogicBrokerModal";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import ADIColors from "@NA/Utils/ADIColors";

interface OwnProps {
    formattedExpDate: string;
    canUserAccess: boolean;
    canUserAcceptAndCheckout: boolean;
    quoteDetails?: OrderModel;
    isCartNotificationModalOpen: boolean;
    closeModalCartNotification: () => void;
    isNonReturnableModalOpen: boolean;
    isLogicBrokerModalOpen: boolean;
    closeModalNonReturnable: () => void;
    closeModalLogicBroker: () => void;
    acceptCheckout: (url: string, customerOrderId: string) => void;
    checkNonReturnableProducts: (url: string, customerOrderId: string) => void;
    AgreeAndContinueCheckout: (url: string, customerOrderId: string) => void;
    continueAndCheckoutFromLB: (url: string, customerOrderId: string) => void;
    isAcceptCheckoutDisable: boolean;
    isQuoteExpired: (dateVal: any) => boolean;
}

type Props = OwnProps & HasHistory;

export interface ADIRfqQuoteDetailsBottomTotalSectionStyles {
    buttonContainer?: InjectableCss;
    totalSection?: InjectableCss;
    totalText?: TypographyProps;
    totalValue?: TypographyProps;
    buttonSection?: InjectableCss;
    acceptAndCheckoutButton?: ButtonPresentationProps;
}

export const adiRfqQuoteDetailsBottomTotalSectionStyles: ADIRfqQuoteDetailsBottomTotalSectionStyles = {
    buttonContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            width: 100%;
            padding-bottom: 80px;
            background: ${getColor("common.background")};
            @media only screen and (max-width: 767px) {
                background-color: ${getColor("common.background")};
                padding: 13px 15px;
                box-shadow: 0 -3px 8px 0 rgba(0, 0, 0, 0.4);
                display: flex;
                flex-direction: row;
                align-items: center;
                position: fixed;
                width: 100%;
                left: 0;
                bottom: 0;
                justify-content: flex-end;
                z-index: 9;
                padding-top: 24px !important;
            }
        `,
    },
    totalSection: {
        css: css`
            display: flex;
            flex-direction: row;
            @media only screen and (max-width: 576px) {
                padding: 0;
                justify-content: flex-end;
                flex-direction: column;
                align-items: flex-end;
            }
        `,
    },
    totalText: {
        css: css`
            font-size: 16px;
            line-height: 26px;
            letter-spacing: normal;
            text-align: right;
            color: ${getColor("text.main")};
            @media only screen and (max-width: 767px) {
                font-size: 14px;
                font-weight: 600;
                line-height: 1;
                white-space: normal;
            }
        `,
    },
    totalValue: {
        css: css`
            font-size: 16px;
            font-weight: 800;
            line-height: 26px;
            letter-spacing: normal;
            margin-left: 8px;
            color: ${getColor("text.main")};
            @media only screen and (max-width: 767px) {
                text-align: right;
                line-height: 22px;
                margin-left: 0px;
            }
        `,
    },
    buttonSection: {
        css: css`
            margin-top: 24px;
            @media only screen and (max-width: 576px) {
                margin-top: 0px;
            }
        `,
    },
    acceptAndCheckoutButton: {
        css: css`
            width: 240px;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            color: ${getColor("common.background")};
            border-radius: 4px;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-bottom: 0;
            @media only screen and (max-width: 767px) {
                width: 218px;
                height: auto;
                min-height: 40px;
                margin: 0 0 0 13px;
                padding: 11px 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            &:disabled {
                background: ${ADIColors.blue8};
                border-color: transparent;
            }
        `,
    },
};

const styles = adiRfqQuoteDetailsBottomTotalSectionStyles;

const ADIRfqQuoteDetailsBottomTotalSection: FC<Props> = ({
    formattedExpDate,
    canUserAccess,
    canUserAcceptAndCheckout,
    quoteDetails,
    isCartNotificationModalOpen,
    closeModalCartNotification,
    isNonReturnableModalOpen,
    isLogicBrokerModalOpen,
    closeModalNonReturnable,
    closeModalLogicBroker,
    acceptCheckout,
    checkNonReturnableProducts,
    AgreeAndContinueCheckout,
    continueAndCheckoutFromLB,
    isAcceptCheckoutDisable,
    isQuoteExpired,
}) => {
    const expiryDate = quoteDetails?.properties["expiryDate"];

   const currentDate = new Date(); // Current date compare for expiry date --- P21 Change
    const compareExpiryDate = (expiryDate: any) => {
        const expiry = new Date(expiryDate);
        const currentDate = new Date();
        expiry.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        if (expiry < currentDate) return true;
        else return false;
    };
    
    
    const disabledButton =
        quoteDetails?.properties["isZeroPriceQuote"] === "Y" ||
        quoteDetails?.orderLines?.length === 0 ||
        quoteDetails?.invoiceOrderLines[0]?.orderTotal === 0 ||
        canUserAccess ||
        canUserAcceptAndCheckout === false ||
        //isQuoteExpired(expiryDate) ||
      //---P21 Change
        compareExpiryDate(expiryDate) ||
        isAcceptCheckoutDisable ||
        (formattedExpDate === "Invalid. Date");
    const filteredLbWithNonZeroQty = quoteDetails?.orderLines?.filter(item => item?.properties?.logicBroker?.toLowerCase() === 'yes' && Number(item.qtyOrdered) !== 0)
    

    return (
        <StyledWrapper {...styles.buttonContainer}>
            <StyledWrapper {...styles.totalSection}>
                <Typography as="p" {...styles.totalText}>
                    {translate("Material Total: ")}
                </Typography>
                <Typography as="p" {...styles.totalValue}>
                    {quoteDetails?.invoiceOrderLines[0]?.amountDisplay}
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.buttonSection}>
                <Button
                    disabled={disabledButton}
                    {...styles.acceptAndCheckoutButton}
                    onClick={() =>
                        acceptCheckout("/Checkout/ReviewAndPay?cartId=", `${quoteDetails?.insiteCustomerOrderId}`)
                    }
                    
                >
                    {translate("Accept & Checkout")}
                </Button>
            </StyledWrapper>
            <ADIRfqPopupNonReturnableModal
                quoteDetails={quoteDetails}
                isNonReturnableModalOpen={isNonReturnableModalOpen}
                closeModalNonReturnable={closeModalNonReturnable}
                AgreeAndContinueCheckout={AgreeAndContinueCheckout}
            />
            {
                filteredLbWithNonZeroQty && filteredLbWithNonZeroQty.length > 0 &&
                <ADILogicBrokerModal
                    quoteDetails={quoteDetails}
                    isLogicBrokerModalOpen={isLogicBrokerModalOpen}
                    closeModalLogicBroker={closeModalLogicBroker}
                    AgreeAndContinueCheckout={continueAndCheckoutFromLB}
                />
            }
            
            <ADIRfqPopupCartNotificationModal
                isCartNotificationModalOpen={isCartNotificationModalOpen}
                closeModalCartNotification={closeModalCartNotification}
                quoteDetails={quoteDetails}
                checkNonReturnableProducts={checkNonReturnableProducts}
            />
        </StyledWrapper>
    );
};

export default withHistory(ADIRfqQuoteDetailsBottomTotalSection);
